import React from 'react';
import { Loader } from '../Loader';
import * as S from './styled';
export const Loading = ({ isLoading, size = 'large', variant = 'transparent', loaderPosition = 'center', children, }) => {
    return (React.createElement(S.Container, { "$isLoading": isLoading },
        children,
        isLoading && (React.createElement(S.OverlayContainer, { "$loaderPosition": loaderPosition, "$variant": variant, "data-testid": "Loading.Overlay" },
            React.createElement(Loader, { size: size })))));
};
